import Transport, { limit, offset } from '../../common/services/api/Transport';

const transport = new Transport();

export const getMeetingActions = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/${meetingId}/actions` });
        return result.data.statusCode === 200 ? result.data.data.actions : [];
    } catch (error) {
        return null;
    }
};

export const getActions = async pageNumber => {
    try {
        const result = await transport.get({ path: `actions?limit=${limit}&offset=${offset(pageNumber)}` });
        return result.data.statusCode === 200
            ? { ...result.data.data, count: Math.ceil(result.data.data.count / limit) }
            : {};
    } catch (error) {
        return null;
    }
};

export const getPinnedActions = async () => {
    try {
        const result = await transport.get({ path: `actions/pinned` });
        return result.data.statusCode === 200 ? { ...result.data.data } : {};
    } catch (error) {
        return null;
    }
};

export const getAction = async actionId => {
    try {
        const result = await transport.get({ path: `actions/${actionId}` });
        return result.data.statusCode === 200
            ? { ...result.data.data, pageNumber: Math.ceil(result.data.data.index / limit) }
            : {};
    } catch (error) {
        return null;
    }
};

export const getActionsAcl = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/${meetingId}/actions/acl` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const createAction = async (meetingId, actionData) => {
    try {
        const result = await transport.post({ path: `meetings/${meetingId}/actions`, data: actionData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const updateAction = async (meetingId, actionData) => {
    try {
        const result = await transport.put({
            path: `meetings/${meetingId}/actions/${actionData._id}`,
            data: actionData,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const markActionAsDone = async actionId => {
    try {
        const result = await transport.put({
            path: `actions/${actionId}/mark-as-done`,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const pinAction = async actionId => {
    try {
        const result = await transport.put({
            path: `actions/${actionId}/pin`,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const deleteAction = async (meetingId, actionId) => {
    try {
        const result = await transport.delete({ path: `meetings/${meetingId}/actions/${actionId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};
